const c = {
  name: "Hands10000",
  dimensions: { width: 35, height: 30 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 35 30" style="enable-background:new 0 0 35 30;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9,11.5l-2-2.1C5.6,7.8,3.1,7.6,1.4,9c-1.7,1.4-1.9,3.9-0.5,5.6l1.9,2.3l6.7,7.5C12.8,28,17.3,30,22,30
			c7.2,0,13-5.8,13-13v-6c0,0,0,0,0,0V8c0-2.2-1.8-4-4-4c-0.8,0-1.6,0.2-2.2,0.7C28.2,3.1,26.8,2,25,2c-0.8,0-1.6,0.2-2.2,0.7
			C22.2,1.1,20.8,0,19,0c-1.7,0-3.2,1.1-3.8,2.6C14.6,2.2,13.8,2,13,2c-2.1,0-4,1.6-4,3.8V11.5z M19,2c1.1,0,2,0.9,2,2v9
			c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2V4C17,2.9,17.9,2,19,2z M19,17c1.2,0,2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4
			c1.7,0,3.2-1.1,3.8-2.7c0.6,0.4,1.4,0.7,2.2,0.7c0.7,0,1.4-0.2,2-0.5V17c0,6.1-4.9,11-11,11c-4.2,0-8.1-1.8-10.9-4.9l-6.7-7.5
			l-1.9-2.3c-0.7-0.8-0.6-2.1,0.2-2.8c0.8-0.7,2.1-0.6,2.8,0.2l0,0l3.8,4C10,16.1,11.4,17,13,17c1.2,0,2.3-0.5,3-1.3
			C16.8,16.5,17.8,17,19,17z M33,8v3c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2V8c0-1.1,0.9-2,2-2C32.1,6,33,6.9,33,8z M23,13V6
			c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v7c0,1.1-0.9,2-2,2C23.9,15,23,14.1,23,13z M15,5.8v7.4c0,0.9-0.8,1.8-2,1.8s-2-0.9-2-1.8V5.8
			C11,4.9,11.8,4,13,4S15,4.9,15,5.8z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Hands10000
};
